import React from "react";
import { Type } from 'react-spark';

class CreditCardPromoModal extends React.Component {
    render() {
        const { isOpen, onClose } = this.props;

        return (
            isOpen && (
                <div className="credit-card-promo-modal" style={{ display: "flex" }}>
                    <div className="credit-card-promo-modal-content">
                        <span className="credit-card-promo-modal-close" onClick={onClose}>
                            <svg className="sprk-c-Icon sprk-c-Icon--xl" viewBox="0 0 100 100">
                                <use xlinkHref="#close" />
                            </svg>
                        </span>
                        <div className="sprk-u-pbl">
                            <h5>Legal disclosure</h5>
                        </div>
                        <Type.BodyTwo>
                            &dagger;The Credit Card Reduction Day Promotion expires at 11:59 pm ET on March 24, 2025.
                            The offer is only available to clients who close a personal loan before the deal expires.
                            Offer is non-transferable and cannot be retroactively applied to previously closed loans.
                            Offer cannot be combined with other Rocket Loans offers. This is not a commitment to lend.
                            E-gift card will be mailed within 30 days of closing.
                        </Type.BodyTwo>
                    </div>
                </div>
            )
        );
    }
}

export default CreditCardPromoModal;
